/**
 * Anzeigename eines GMs.
 *
 * Niemals `username` — der ist bei vielen GMs die E-Mail-Adresse, und diese
 * Seiten sind öffentlich. Die öffentlichen Routen liefern `username` deshalb
 * gar nicht mehr mit (siehe PUBLIC_GM_ATTRIBUTES in server/routes/teamOwners.js).
 *
 * Standard ist Gamertag vor Vorname — so steht in Listen und Zeilen wie
 * „GM: X" der Name, unter dem man den GM im Spiel findet. Auf Profilkarten, wo
 * der Gamertag ohnehin ein eigenes Feld hat, kehrt `preferFirstName` die
 * Reihenfolge um, damit die Überschrift nicht dasselbe zweimal zeigt.
 *
 * Alle Nutzer der Liga haben einen Vornamen, der Rückfall greift also immer.
 * Ist doch einmal beides leer, kommt '' zurück — die aufrufende Stelle blendet
 * die Zeile dann aus, statt eine Lücke zu zeigen.
 */
export const gmDisplayName = (user, { preferFirstName = false } = {}) => {
  if (!user) return '';
  const firstName = (user.firstName || '').trim();
  const gamertag = (user.gamertag || '').trim();
  return preferFirstName ? (firstName || gamertag) : (gamertag || firstName);
};

/** Initiale für Avatare — ohne Namen ein '?'. */
export const gmInitial = (user, options) =>
  gmDisplayName(user, options).charAt(0).toUpperCase() || '?';

export default gmDisplayName;
